/**
 * Shape contract berdasarkan MODEL AKTIF backend, bukan migration lama.
 * Ini bukan schema validator database; tujuannya memberi vocabulary canonical
 * untuk mapper/feature React agar alias field lama tidak menyebar ke seluruh UI.
 */
export const MODEL_CONTRACT = Object.freeze({
  user: Object.freeze({
    role: ["role_slug", "role.slug"],
    locationId: "lokasi_id",
    locationName: "lokasi_nama",
    superadminFlag: "is_superadmin",
  }),
  registration: Object.freeze({
    primaryCode: "kode",
    locationId: "lokasi_id",
    locationName: "lokasi_nama",
    serviceDate: "tanggal_pelayanan",
    serviceType: "jenis_layanan",
    status: "status",
    queueNumber: "nomor_antrian",
    queueDisplay: "nomor_antrian_display",
  }),
  screening: Object.freeze({
    registrationKey: "registration_id",
    officer: "petugas",
    conclusion: "kesimpulan",
  }),
  clinic: Object.freeze({
    registrationKey: "registration_id",
    officer: "petugas_klinik",
    responsibleOfficer: "petugas_pj",
    vaccineStatus: "status_vaksinasi",
    vaccines: "vaksin_diberikan",
  }),
  billing: Object.freeze({
    registrationKey: "registration_id",
    invoiceId: "invoice_id",
    total: "total_bayar",
    status: "status",
    paymentMethod: "metode",
    eicvOfficer: "petugas_eicv",
  }),
  staff: Object.freeze({
    locationId: "lokasi_id",
    legacyLocationText: "wilker",
    active: "is_active",
    servicePosition: "posisi_pelayanan",
  }),
  whatsappConversation: Object.freeze({
    locationId: "lokasi_id",
    registrationId: "registration_id",
    billingId: "billing_id",
  }),
});

export const SERVICE_LOCATION_FALLBACKS = Object.freeze([
  Object.freeze({
    id: 1,
    name: "Kantor Induk BKK Pangkalpinang",
    shortName: "Kantor Induk",
    address: "Pangkalpinang",
  }),
  Object.freeze({
    id: 2,
    name: "Wilker Tanjung Pandan",
    shortName: "Wilker Tanjung Pandan",
    address: "Tanjung Pandan",
  }),
]);
